import React, { Component } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import intl from 'react-intl-universal' //增加国际化https://www.codeleading.com/article/9015170636/
import { ConfigProvider } from 'antd'
import zh_CN from 'antd/es/locale/zh_CN'
import en_US from 'antd/es/locale/en_US'
import Login from '../component/registerAndLogin/login'

import './index.less'
import routes from './routes'

const locales = {
	'zh-CN': require('../locales/zh_CN.json'),
	'en-US': require('../locales/en_US.json')
}

class App extends Component {
	constructor(props) {
		super(props)
		this.state = {
			lang: 'zh-CN',
			locale: zh_CN,
			querString: '',
			defaultUrl: ''
		}
	}

	componentDidMount() {
		let { defaultUrl, querString } = this.state
		if (window.location.search) {
			querString = window.location.search?.split('?')[1].split('=')[1]
			routes.map((item, index) => {
				if (item.path.startsWith(`/${querString}`)) {
					defaultUrl = item.path
				}
			})
			this.setState({
				lang: this.getCookie('seller_site_lang'),
				defaultUrl,
				querString,
			}, () => {
				this.getLanguage(this.state.lang)
				var strSpm = 'seller' + (this.state.lang.split('-')[0] == 'zh' ? 'cn' : 'en')
				var currentMeta = document.createElement('meta')
				currentMeta.name = "spm-a"
				currentMeta.content = strSpm
				document.getElementsByTagName('head')[0].appendChild(currentMeta)
			})
		} else {
			this.setState({
				lang: this.getCookie('seller_site_lang'),
			}, () => {
				this.getLanguage(this.state.lang)
				var strSpm = 'seller' + (this.state.lang.split('-')[0] == 'zh' ? 'cn' : 'en')
				var currentMeta = document.createElement('meta')
				currentMeta.name = "spm-a"
				currentMeta.content = strSpm
				document.getElementsByTagName('head')[0].appendChild(currentMeta)
			})
		}
		this.asyncImportJs()
		this.acynsTDSdk()
		setTimeout(() => {
			this.asyncTrackSdk()
		}, 300);

	}
	acynsTDSdk(){
		(function () {
			try {
				let s = document.createElement("script");
				let x = document.getElementsByTagName("script")[0];
				s.type = "text/javascript";
				s.src = "https://static.tongdun.net/monitor/monitor.js";
				x.parentNode.insertBefore(s, x);
			} catch (e) { }
		})();
	}
	asyncImportJs() {
		(function () {
			try {
				let s = document.createElement("script");
				let x = document.getElementsByTagName("script")[0];
				s.type = "text/javascript";
				s.src = "https://js.dhresource.com/seller/common/jquery.js";
				x.parentNode.insertBefore(s, x);
			} catch (e) { }
		})();
	}

	asyncTrackSdk() {
		(function () {
			try {
				let s = document.createElement("script");
				let x = document.getElementsByTagName("body")[0];
				s.type = "text/javascript";
				s.src = "//js.dhresource.com/seller/common/track/trackwebsdk.js?v=1646997531153";
				x.parentNode.appendChild(s, x);
			} catch (e) { }
		})();
	}

	getCookie(name) {
		var strcookie = document.cookie; //获取cookie字符串
		var arrcookie = strcookie.split("; "); //分割
		var lang1 = '',
			lang2 = '',
			flag = false;
		//遍历匹配
		for (var i = 0; i < arrcookie.length; i++) {
			var arr = arrcookie[i].split("=");
			if (arr[0] == name) {
				flag = true
				lang1 = arr[1].split('_').join('-');
			} else {
				lang2 = 'zh-CN'
			}
		}
		return flag ? lang1 : lang2
	}


	//多语言翻译
	getLanguage(lang) {
		intl.init({
			currentLocale: lang,
			locales,
		}).then(() => {
			this.setState({
				lang,
				locale: lang == 'zh-CN' ? zh_CN : en_US,
			})
		})
	}


	render() {
		const { locale, defaultUrl } = this.state
		return (
			<div className="col-main-warp1">
				<ConfigProvider locale={locale}>
					<div className="container" style={{ marginTop: '-4px' }}>
						<div className="container-right">
							<div className="container-content">
								<Switch>
									{
										routes.map(route => {
											return (
												<Route key={route.path} path={route.path} component={route.component} />
											)
										})
									}
									{/* <Redirect to="/passport/login" /> */}
								</Switch>
								{/* <Login /> */}
							</div>
						</div>
					</div>
				</ConfigProvider>
			</div>
		)
	}
}
export default App